import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import InvoicePDF from "../Lead/ViewSentPdf/Pdf2";

const ViewSentPDFPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { leadInfo, quotation } = location.state || {};
  
  console.log("PDF Preview - leadInfo:", leadInfo);
  console.log("PDF Preview - quotation:", quotation);

  if (!leadInfo || !quotation) {
    return (
      <div style={{ padding: "20px" }}>
        <p>No quotation data found. Please go back and try again.</p>
        <button onClick={() => navigate(-1)} style={{ padding: "8px 12px", background: "#6c757d", color: "white", border: "none", borderRadius: "5px" }}>
          ← Back
        </button>
      </div>
    );
  }

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <div style={{ padding: "10px", display: "flex", justifyContent: "space-between", background: "#f8f9fa" }}>
        <button onClick={() => navigate(-1)} style={{ padding: "8px 12px", background: "#6c757d", color: "white", border: "none", borderRadius: "5px" }}>
          ← Back
        </button>
      </div>

      <PDFViewer width="100%" height="100%">
        <InvoicePDF leadInfo={leadInfo} quotation={quotation} />
      </PDFViewer>
    </div>
  );
};

export default ViewSentPDFPreview;